import { createFileRoute, redirect } from '@tanstack/react-router';
import { GroundworkReportPage } from '@/features/portal-groundwork/GroundworkReportPage';

// Grondwerk-fotorapport (docs/portal.md §6). Only for a party with the module on;
// the API refuses the rest (403), this only keeps the screen from offering it.
export const Route = createFileRoute('/portal/_portal/groundwork')({
  beforeLoad: ({ context }) => {
    if (!context.me.modules.includes('GROUNDWORK_REPORT'))
      throw redirect({ to: '/portal/account' });
  },
  component: GroundworkRoute,
});

function GroundworkRoute() {
  const { me } = Route.useRouteContext();
  return <GroundworkReportPage me={me} />;
}
